import Nav from "./Navigation";
import Footer from "./Footer";
import ProjectsSection from "./ProjectsSection";

const Projects = () => {

  return (
    <div>
      <Nav />
      <ProjectsSection />
      <Footer />
    </div>
  )
}

export default Projects;